import 'angular:locale/data:fr-CA';
import 'angular:locale/data:es-MX';
import 'angular:locale/data:en-US';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
